export const forCastCard = {
  display: 'flex',
  flexDirection: 'column',
  padding: '15px',
  background: '#F8F8F8',
  boxShadow: 'none',
  borderRadius: '5px',
  // border:"1px solid rgba(17, 35, 71, 0.1)",
};
export const centerContent = {
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
};
export const postCntl = {
  position: 'relative',
  bottom: '7px',
};
export const accu = {
  color: '#000000',
};
export const medium = {
  color: '#6537B3',
};
export const gray = {
  color: '#666666',
};
